import apiClient from "../authentication/utils/core/axios";

const BASE = "/admin/moderation";

const ModerationAPI = {
  // GET /admin/moderation?skip&limit&status&type&reason&search
  fetchAllEvents: async ({ skip = 0, limit = 50, status, type, reason, search } = {}) => {
    // matches FastAPI route: GET /api/v1/admin/moderation/ -- status/type/reason/search
    // are applied server-side (see #12) so a filter isn't limited to whatever
    // page of events happens to already be loaded.
    const res = await apiClient.get(`${BASE}`, { params: { skip, limit, status, type, reason, search } });
    if (res.status !== 200) throw new Error("Failed to fetch moderation events");
    return res.data;
  },

  // GET /admin/moderation/group-posts?skip&limit&status&type&reason&search
  fetchGroupPostEvents: async ({ skip = 0, limit = 50, status, type, reason, search } = {}) => {
    const res = await apiClient.get(`${BASE}/group-posts`, { params: { skip, limit, status, type, reason, search } });
    if (res.status !== 200) throw new Error("Failed to fetch group-post moderation events");
    return res.data;
  },

  // GET /admin/moderation/post/{post_id}
  fetchEventsByPost: async (postId) => {
    const res = await apiClient.get(`${BASE}/post/${postId}`);
    if (res.status !== 200) throw new Error("Failed to fetch post moderation events");
    return res.data; // array of ModerationEventOut
  },

  // POST /admin/moderation  (create manual event)
  createManualEvent: async (payload) => {
    // payload must match ModerationEventCreate { post_id, user_id, reason, type, status?, details? }
    // No trailing slash -- the route is registered as "" (see admin_mod_router.post("", ...)),
    // so the old "/${BASE}/" form worked only via Starlette's redirect-slashes fallback (#13).
    const res = await apiClient.post(`${BASE}`, payload);
    if (res.status !== 201) throw new Error("Failed to create moderation event");
    return res.data;
  },

  // POST /admin/moderation/analyze_and_flag  (admin-triggered analysis + auto-flag)
  analyzeAndFlag: async ({ post_id, user_id, content }) => {
    const res = await apiClient.post(`${BASE}/analyze_and_flag`, null, {
      params: { post_id, user_id, content }, // 👈 query params
    });
    if (![201, 200].includes(res.status)) throw new Error("Analyze/flag failed");
    return res.data; // may be null if not flagged
  },

  // POST /admin/moderation/reanalyze/{post_id}
  reanalyzePost: async (postId) => {
    const res = await apiClient.post(`${BASE}/reanalyze/${postId}`);
    if (![200].includes(res.status)) throw new Error("Reanalyze failed");
    return res.data; // may be null if not flagged
  },

  // PATCH /admin/moderation/{scope}/{event_id}/status?new_status=approved|rejected|reviewed|open
  // scope: "post" | "group" -- selects moderation_events vs group_moderation_events,
  // since the two tables have independent id sequences that can collide.
  updateStatus: async ({ eventId, new_status, scope = "post" }) => {
    const res = await apiClient.patch(`${BASE}/${scope}/${eventId}/status`, null, {
      params: { new_status },
    });
    if (res.status !== 200) throw new Error("Failed to update moderation status");
    return res.data;
  },
};

export default ModerationAPI;
